import React from 'react'
import ForgotPasswordTemplate from '../../templates/ForgotPassword/ForgotPasswordTemplate'

const ForgotPassword = () => {
  return (
    <ForgotPasswordTemplate />
  )
}

export default ForgotPassword